/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2019 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.account_data';
export const Component = loadable(
  () => import('./container/AccountDataContainer')
);
export { default as propsFormatter } from './propsFormatter';
